export default __webpack_public_path__ + "static/media/3114.c19bfbf9.jpg";